import { useState } from 'react';
import { roleLabel, roleColor, situacaoEleitLabel, situacaoEleitColor, limparTelefone, gerarMsgVerificacao } from '../utils/helpers';

export default function TreeNode({ node, level = 0 }) {
  const [open, setOpen] = useState(level < 2);
  const hasKids = node.children?.length > 0;
  const tel = limparTelefone(node.telefone || '');
  const waUrl = tel
    ? `https://wa.me/55${tel}?text=${encodeURIComponent(gerarMsgVerificacao(node.nome || node.login, node.cpf))}`
    : null;

  return (
    <div style={{ marginLeft: level * 20, marginBottom: 4 }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px',
        background: level === 0 ? '#f0f8ff' : '#fff',
        borderRadius: 8, border: `1px solid ${roleColor(node.role)}`,
        marginBottom: 3, flexWrap: 'wrap',
      }}>
        {hasKids
          ? <button onClick={() => setOpen(o => !o)}
              style={{ background: 'none', border: 'none', color: 'var(--primary)', cursor: 'pointer', fontWeight: 700, fontSize: 13, padding: 0 }}>
              {open ? '▼' : '▶'}
            </button>
          : <span style={{ width: 16 }} />}

        <strong style={{ fontSize: 13, minWidth: 150 }}>{node.nome || node.login}</strong>
        <span style={{ fontSize: 11, color: roleColor(node.role), fontWeight: 700 }}>{roleLabel(node.role)}</span>
        {node.municipio && <span style={{ fontSize: 11, color: '#555' }}>📍 {node.municipio}</span>}
        <span style={{ fontSize: 11, color: situacaoEleitColor(node.situacao_eleitoral), fontWeight: 600 }}>
          {situacaoEleitLabel(node.situacao_eleitoral)}
        </span>
        {node.cpf      && <span style={{ fontSize: 11, color: '#777' }}>🪪 {node.cpf}</span>}
        {node.telefone && <span style={{ fontSize: 11, color: '#777' }}>📞 {node.telefone}</span>}
        {waUrl && (
          <a href={waUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-wa" style={{ fontSize: 11, padding: '3px 9px' }}>
            📲 WhatsApp
          </a>
        )}
        {hasKids && <span style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--primary)', fontWeight: 700 }}>{node.children.length} abaixo</span>}
      </div>
      {open && hasKids && node.children.map(c => <TreeNode key={c.id} node={c} level={level + 1} />)}
    </div>
  );
}
